// Training preferences — how the athlete likes a session put together. Unlike
// the per-session style picker, these cut across every style: "pair my lifts"
// should hold whether today is Strength, Hypertrophy or a Mixed session.
//
// The first entry of each list is the default and reproduces the behaviour from
// before these preferences existed, so an untouched profile generates exactly
// as it always has.

export const REST_STYLE_OPTIONS = [
  {
    value: "full",
    label: "Full rest",
    description: "Rest fully between sets of the same exercise.",
  },
  {
    value: "paired",
    label: "Pair exercises",
    description:
      "Fill the rest with an exercise for a different muscle group, so you train while each muscle recovers.",
  },
  {
    value: "active",
    label: "Active rest",
    description:
      "Fill the rest with a light mobility or core drill instead of standing still.",
  },
];

export const SESSION_PACE_OPTIONS = [
  {
    value: "steady",
    label: "Steady",
    description: "Standard rest periods for each style.",
  },
  {
    value: "dense",
    label: "Dense",
    description:
      "Shorter rests and more full-body movement — high energy, little standing around.",
  },
];

export const REST_STYLES = REST_STYLE_OPTIONS.map((o) => o.value);
export const SESSION_PACES = SESSION_PACE_OPTIONS.map((o) => o.value);
export const DEFAULT_REST_STYLE = REST_STYLES[0];
export const DEFAULT_SESSION_PACE = SESSION_PACES[0];

// Matches the API's cap — long enough for a few sentences, short enough that it
// cannot crowd the rest of the prompt.
export const MAX_TRAINING_PREFERENCES_LENGTH = 500;
